import randomize from 'randomatic';

// eslint-disable-next-line import/prefer-default-export
export function randomString(len) {
  return randomize('a0', len);
}



// WEBPACK FOOTER //
// ./src/services/random.js